import { Component, Input, OnInit } from '@angular/core';
import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';

import { AppUpdateConfig } from '../../shared/models/AppUpdateConfig';

@Component({
  selector: 'app-update-app',
  templateUrl: './update-app.page.html',
  styleUrls: ['./update-app.page.scss'],
})
export class UpdateAppPage implements OnInit {

  @Input() remoteConfigValues: AppUpdateConfig = {} as AppUpdateConfig;

  constructor() { }

  ngOnInit() {
  }

  public toDownload = async () => await Browser.open({ url: this.url() });

  private url = (): string => {
    let platformUrl: string = '';
    switch (Capacitor.getPlatform()) {
      case 'ios':
        platformUrl = this.remoteConfigValues.Platform?.ios || '';
        break;
      case 'android':
        platformUrl = this.remoteConfigValues.Platform?.android || '';
        break;
    }
    return platformUrl;
  }

}
